import _ from 'lodash';
import moment from 'moment';
var Filter = /** @class */ (function () {
    function Filter(vehicles) {
        this._vehicles = vehicles;
    }
    Filter.prototype.vehicleType = function (vehicleType) {
        vehicleType &&
            (this._vehicles = _.filter(this._vehicles, ['vehicleType', vehicleType]));
        return this;
    };
    Filter.prototype.manufacturer = function (manufacturer) {
        manufacturer &&
            (this._vehicles = _.filter(this._vehicles, ['make', manufacturer]));
        return this;
    };
    Filter.prototype.model = function (model) {
        model && (this._vehicles = _.filter(this._vehicles, ['model', model]));
        return this;
    };
    Filter.prototype.year = function (year) {
        if (_.isEmpty(year)) {
            return this;
        }
        this._vehicles = _.filter(this._vehicles, function (v) {
            var range = [
                moment(v['yearFrom'], 'YYYY'),
                !_.isNull(v['yearTo']) ? moment(v['yearTo'], 'YYYY') : moment(),
            ];
            return moment(year, 'YYYY').isBetween(range[0], range[1], 'years', '[]');
        });
        return this;
    };
    Filter.prototype.value = function () {
        return this._vehicles;
    };
    return Filter;
}());
export default Filter;
